export const locale = {
    lang: "en",
    data: {
        noise_sensor: "Noise Sensor",
        acoustic_limiter: "Acoustic Limiter",
        GLOBAL: {
            SavedChanges: "Saved Changes",
            CreatedSuccess: "Created Succesfully",
        },
        USERS: {
            Users: "Users",
            User: "User",
            Name: "Name",
            Email: "Email",
            Admin: "Admin",
            IsAdmin: "Is Admin?",
            Password: "Password",
            ADD: "ADD",
            SAVE: "SAVE",
            CANCEL: "CANCEL",
            Create: "Create",
            UserName: "Namw",
            BasicInfo: "Basic Info",
            PasswordPolicy: "Password must contain at least {{minLength}} characters.",
            PasswordRequired: "Password is required",
            PasswordMinLength: "Password must contain at least {{minLength}} characters.",
            PasswordReset: "Password reset",
            PasswordResetTitle: "Reset user password",
            PasswordResetSuccess: "Password updated successfully",
            ResetPasswordButton: "Reset password",
            NewPassword: "New password",
            ConfirmPassword: "Confirm password",
            ConfirmPasswordRequired: "Password confirmation is required",
            PasswordsDoNotMatch: "Passwords do not match",
            Projects: "Projects",
            Companies: "Companies",
        },
        COMPANIES: {
            Companies: "Companies",
            Name: "Name",
            Street: "Street",
            City: "City",
            ZipCode: "Zip Code",
            Country: "Country",
            BasicInfo: "Basic Info",
            Company: "Company",
            CompanyName: "Company Name",
            Address: "Address",
            ADD: "ADD",
            SAVE: "SAVE",
            CANCEL: "CANCEL",
            Projects: "Projects",
            Create: "Create",
        },
        DEVICE: {
            ALARM: {
                AlarmDeleteTitle: "Alert",
                AlarmDeleteMessage: "This alarm has {{activeEvents}} active events. \nAre you sure you want to delete it?",
            },
        },
        DEVICES: {
            ActiveProject: "Active Project",
            Devices: "Devices",
            Name: "Name",
            Manufacturer: "Manufacturer",
            Model: "Model",
            BasicInfo: "Basic Info",
            SerialNumber: "Serial Number",
            DataFrequency: "Data Frequency (Seconds)",
            DataFrequencyDevice: "Device Data Frequency (Seconds): ",
            DataFrequencyCustom: "Custom Data Frequency (Seconds): ",
            LF010Host: "LF010 Host / IP",
            LF010HostHelp: "Host used to poll device data.",
            LF010HostPlaceholder: "192.168.1.100",
            LF010Password: "LF010 Password",
            LF010PasswordHelp: "Optional password. Leave empty to use the current default.",
            LF010PasswordPlaceholder: "admin",
            LF010PeriodMapping: "LF010 Period Mapping",
            LF010PeriodMappingHelp: "Map the three fixed LF010 periods to the project periods.",
            LF010DevicePeriod: "LF010 Device Period",
            LF010ProjectPeriodPlaceholder: "Select a project period",
            LF010ApplyAlarm: "Apply LF010 limits after saving",
            LF010ApplyAlarmHelp: "Creates or updates the managed LF010 emission alarm using the selected project-period mapping.",
            LF010ApplyAlarmPendingHelp:
                "You can save the period mapping now. The alarm can be applied after the first LF010 data ingestion provides the emission limits.",
            ProjectPeriod: "Project Period",
            LF010SettingsDisabledWhenActive: "Deactivate the device before changing LF010 settings.",
            LF010LockedBadge: "Live device",
            LF010LockedTitle: "LF010 limits and period mapping are locked while the device is active.",
            LF010LockedDescription:
                "The current LF010 connection and project-period mapping remain visible for reference, but they cannot be edited until the device is deactivated.",
            LF010PeriodMappingLockedHelp: "Deactivate the device to edit the LF010 mapping or change how its live limits are applied.",
            SimOrImei: "SIM or IMEI",
            LastCalibrationDate: "Last Calibration Date",
            DeviceType: "Device Type",
            Protocol: "Protocol",
            Picture: "Picture",
            Comments: "Comments",
            Location: "Location",
            Active: "Active",
            Device: "Device",
            Activate: "Activate",
            Deactivate: "Deactivate",
            Reset: "Reset",
            ConfirmReset: "Reset device {{deviceName}} now? This will stop the measurement first.",
            ResetQueued: "Reset requested",
            ResetAlreadyPending: "A reset is already pending for this device",
            ResetRateLimited: "Please wait {{seconds}} seconds before requesting another reset",
            OperationTypeReset: "Reset",
            OperationTypeGeneric: "Operation",
            OperationPending: "Operation pending",
            OperationInProgress: "Operation in progress",
            OperationRequestedAt: "Requested {{time}}",
            EditLockedBadge: "Locked",
            EditLockedTitle: "This device is active and cannot be edited.",
            EditLockedDescription: "Deactivate this device before changing its settings, image, or special alarms.",
            EditLockedMeta: "Deactivate to unlock all settings",
            Remove: "Remove",
            Create: "Create",
            DeviceInfo: "Device Information",
            SpecialAlarms: "Special alarms",
            SpecialAlarmsHelp:
                "Configure connectivity and power-supply notifications for this device using the project's notification channels.",
            SpecialAlarmConnection: "Notify when the device goes offline or comes back online",
            SpecialAlarmPowerSupply: "Notify when the device is unplugged or plugged back in",
            SpecialAlarmChannels: "Notification channels",
            SpecialAlarmChannelsHelp: "The selected channels are shared by both special-alarm groups on this device.",
            SpecialAlarmChannelsEmpty: "Create project notification channels first to send special alarms from this device.",
            DefaultSvantekConfig: "Default Svantek config",
            DefaultSvantekConfigHelp: "This is the config EMMA applies when the custom override is empty.",
            CustomConfig: "Custom Svantek config",
            CustomConfigDisabledWhenActive: "Deactivate the device before changing the Svantek config override.",
            CustomConfigHelp: "Leave empty to use the default Axioma Svantek configuration shipped by EMMA.",
            CustomConfigPlaceholder: "Paste the full Svantek setup string, starting with #1",
            SvantekFileSync: "SVL sync and file downloads",
            SvantekFileSyncEnabled: "Enable downloads",
            SvantekFileSyncHelp:
                "Enables daily CSV archive downloads, active .SVL logger sync, and Svantek file reads for this device.",
            SvantekBaselineSummary: "EMMA baseline summary",
            SvantekBaselineSummaryHelp: "These defaults stay read-only because EMMA data ingestion depends on them.",
            SvantekOptionalFeatures: "Optional features",
            SvantekOptionalFeaturesHelp: "Visual controls only rewrite the supported Svantek tokens and preserve the rest of the setup.",
            SvantekAdvancedRawConfig: "Advanced raw config",
            SvantekAdvancedRawConfigHelp:
                "The raw string stays authoritative. Edit it directly for unsupported settings or full manual control.",
            SvantekRawConfigPreview: "Custom settings preview",
            SvantekRawConfigMissing: "Missing from default",
            SvantekRawConfigInvalid: "The raw Svantek config could not be parsed. Fix it or clear it to re-enable the visual builder.",
            SvantekCompatibilityWarning:
                "The raw config changes EMMA baseline tokens. The raw value will still be saved, but data compatibility may be affected.",
            SvantekUseInstrumentDefault: "Use instrument default",
            SvantekOn: "On",
            SvantekOff: "Off",
            SvantekEnvironmental: "Environmental",
            SvantekAirport: "Airport",
            SvantekMicrophoneCompensation: "Microphone compensation",
            SvantekFreeFieldCompensation: "Free-field compensation",
            SvantekWaveRecordingMode: "Wave recording mode",
            SvantekWaveRecordingOff: "Off",
            SvantekWaveRecordingContinuous: "Continuous",
            SvantekWaveRecordingSlopePlus: "Slope+",
            SvantekWaveRecordingSlopeMinus: "Slope-",
            SvantekWaveRecordingGradientPlus: "Gradient+",
            SvantekWaveRecordingManual: "Manual",
            SvantekWaveRecordingIntegrationPeriod: "Integr. period",
            SvantekWaveRecordingLevelPlus: "Level+",
            SvantekWaveRecordingLevelMinus: "Level-",
            SvantekWaveRecordingExternal: "External",
            SvantekWaveRecordingAlarm: "Alarm",
            SvantekWaveFileName: "Wave file name",
            SvantekWaveFileNameHelp: "Up to 8 uppercase characters, numbers, or underscores.",
            SvantekWaveFormat: "Format",
            SvantekFormatPcm: "PCM",
            SvantekFormatExtensible: "Extensible",
            SvantekFormatALaw: "A-Law",
            SvantekBitsPerSample: "Bits per sample",
            SvantekBits16: "16 bits",
            SvantekBits24: "24 bits",
            SvantekRecordingTime: "Recording time (s)",
            SvantekRecordingTimeHelp: "Allowed range: 1 to 28800 seconds.",
            SvantekPreTrigger: "Pre-trigger (s)",
            SvantekPreTriggerHelp: "Available for level-trigger modes.",
            SvantekRecordingFilter: "Recording filter",
            SvantekSamplingRate: "Sampling rate",
            SvantekGain: "Gain (dB)",
            SvantekGainHelp: "Allowed range: 0 to 40 dB.",
            SvantekTriggerLevel: "Trigger level (dB)",
            SvantekTriggerLevelHelp: "Allowed range: 24 to 136 dB.",
            SvantekTriggerPeriod: "Trigger period",
            SvantekTriggerPeriodLoggerStep: "Logger step",
            SvantekTriggerPeriodHalfMillisecond: "0.5 ms",
            SvantekTriggerPeriod100Milliseconds: "100 ms",
            SvantekTriggerPeriod1Second: "1 s",
            SvantekTriggerGradient: "Trigger gradient (dB)",
            SvantekTriggerGradientHelp: "Allowed range: 1 to 100 dB per trigger period.",
            SvantekLengthLimit: "Length limit",
            SvantekLengthLimit4Gb: "4 GB file limit",
            SvantekLengthLimitMinutes: "Custom minutes",
            SvantekLengthLimitMinutesValue: "Length limit (min)",
            SvantekFilterZ: "Z filter",
            SvantekFilterA: "A filter",
            SvantekFilterC: "C filter",
            SvantekFilterB: "B filter",
            SvantekSampling48kHz: "48 kHz",
            SvantekSampling24kHz: "24 kHz",
            SvantekSampling12kHz: "12 kHz",
            SvantekSampling6kHz: "6 kHz",
            SvantekBaselineMeasurementMode: "Measurement mode",
            SvantekBaselineMeasurementModeValue: "1/3 octave",
            SvantekBaselineStartSynchronization: "Start synchronization",
            SvantekBaselineStartSynchronizationValue: "15 min",
            SvantekBaselineIntegrationPeriod: "Integration period",
            SvantekBaselineIntegrationPeriodValue: "5 min",
            SvantekBaselineRepetitionCycles: "Repetition cycles",
            SvantekBaselineRepetitionCyclesValue: "Infinite",
            SvantekBaselineLogger: "Logger",
            SvantekBaselineLoggerValue: "On",
            SvantekBaselineProfiles: "Profiles 1/2/3",
            SvantekBaselineProfilesValue: "A/C peak/Fast, A/C peak/Impulse, C/C peak/Fast",
            SvantekBaselineSpectrumFilter: "Spectrum filter",
            SvantekBaselineSpectrumFilterValue: "Z",
            SvantekBaselineLoggerStep: "Logger step",
            SvantekBaselineLoggerStepValue: "1 s",
            SvantekBaselineLeqDetector: "Leq detector",
            SvantekBaselineLeqDetectorValue: "Exponential",
            FolderFTP: "FTP Folder",
            ScheduledRestart: "Scheduled Restart",
            ScheduledRestartEnabled: "Enable automatic restart",
            ScheduledRestartTimezone: "The schedule uses timezone {{timezone}}.",
            ScheduledRestartFrequency: "Frequency",
            ScheduledRestartWeekly: "Weekly",
            ScheduledRestartMonthly: "Monthly",
            ScheduledRestartWeekday: "Day of week",
            ScheduledRestartMonthDay: "Day of month",
            ScheduledRestartHour: "Hour",
            ScheduledRestartMinute: "Minute",
            WeekdaySunday: "Sunday",
            WeekdayMonday: "Monday",
            WeekdayTuesday: "Tuesday",
            WeekdayWednesday: "Wednesday",
            WeekdayThursday: "Thursday",
            WeekdayFriday: "Friday",
            WeekdaySaturday: "Saturday",
            XL3Connection: "XL3 Connection",
            XL3ConnectionType: "Connection Type",
            XL3ConnectionLan: "LAN",
            XL3ConnectionConnect: "NTi Connect",
            XL3Host: "XL3 Host",
            XL3ConnectKey: "Connect Key",
            XL3Password: "XL3 Password",
            TotalStorageMb: "Total storage (MB)",
            TotalStorageMbHelp: "Used to convert NTi free storage from MB to percent.",
            Address: "Address",
            Latitude: "Latitude",
            Longitude: "Longitude",
            SearchAddress: "Find Address",
            SearchingAddress: "Resolving address",
            AddressHelp: "Type an address and resolve it to coordinates.",
            MapHelp: "You can also click directly on the map to set the coordinates.",
            AddressNotFound: "No coordinates were found for that address.",
            GeocodeFailed: "The address could not be resolved right now.",
            ReverseGeocodeFailed: "The coordinates were set, but the address could not be resolved.",
            NewDevice: "New Device",
            ADD: "ADD",
            SAVE: "SAVE",
            CANCEL: "CANCEL",
            Projects: "Projects",
            ConfirmActivate:
                "This device is already activate in project {{project}} with name {{deviceName}}.\nAre you sure you want to activate it?",
            Image: "Image",
            Files: "Files",
            FileName: "Name",
            FileType: "File type",
            FileSize: "Size",
            FileStatus: "Status",
            FileCreationDate: "Creation Date",
            FileUploadDate: "Upload Date",
            AllFileTypes: "All",
            CsvFiles: "CSV",
            SvlFiles: "SVL",
            Xl3Files: "XL3 files",
            FileStartDate: "Start date",
            FileEndDate: "End date",
            ClearFileFilters: "Clear filters",
            FileDateRangeError: "End date must be after or equal to the start date.",
            DownloadFile: "Download",
            RescanFileStorage: "Rescan storage",
            RescanFileStorageCompleted: "{{count}} files recovered",
            ReprocessFile: "Reprocess",
            ReprocessFileQueued: "SVL reprocess queued",
            FileStatusUploaded: "Uploaded",
            FileStatusPendingReprocess: "Pending reprocess",
            FileStatusReprocessing: "Reprocessing",
            FileStatusReprocessFailed: "Reprocess failed",
            DownloadSelectedFiles: "Download selected",
            SelectedFilesCount: "{{count}} selected",
            SelectCurrentPageFiles: "Select current page files",
            SelectFile: "Select {{name}}",
            NoFiles: "No archived files available for this device.",
            NoFilesMatchFilters: "No archived files match the current filters.",
            DropFiles: "Drop Image Here",
            RemoveImage: "Remove Image",
            SearchPlaceholder: "Search",
        },
        PROJECTS: {
            Projects: "Projects",
            Project: "Project",
            BasicInfo: "Basic Info",
            Name: "Name",
            Timezone: "Timezone",
            Create: "Create",
            ProjectName: "Project Name",
            Devices: "Devices",
            Alarms: "Alarms",
            ADD: "ADD",
            SAVE: "SAVE",
            CANCEL: "CANCEL",
            Periods: "Periods",
            ProjectPeriodName: "Name",
            ProjectPeriodStart: "Start Time",
            ProjectPeriodEnd: "End Time",
            ProjectPeriodHours: "Hours",
            ProjectPeriodMinutes: "Minutes",
            ProjectPeriodNew: "New Period",
            ProjectPeriodEdit: "Edit Period",
            ProjectPeriodSave: "Save Period",
            ProjectPeriodIntervals: "Intervals",
            ProjectPeriodAddInterval: "Add interval",
            ProjectPeriodSplit: "Split",
            ProjectPeriodError: "WARNING: End hour is before start hour. You are creating a period that span multiple days",
            ProjectPeriodsTimelineHint: "Use the timeline to review each period interval. Edit a period to manage its intervals.",
            ProjectPeriodSplitHint: "Click to split here",
            ProjectPeriodsEmptyTitle: "Create the first period",
            ProjectPeriodsEmptyDescription: "Add the logical periods you need and assign one or more intervals to each of them.",
            Dateformat: "Date Format",
            Example: "Example",
            NotificationChannels: "Notification Channels",
            NotificationChannelsHelp: "Create reusable project-owned channels and select them from device or project alarms.",
            NotificationChannelAdd: "Add channel",
            NotificationChannelNew: "New channel",
            NotificationChannelEdit: "Edit channel",
            NotificationChannelSave: "Save channel",
            NotificationChannelName: "Channel name",
            NotificationChannelTypeLabel: "Channel type",
            NotificationChannelEnabled: "Enabled",
            NotificationChannelRemove: "Remove channel",
            NotificationChannelSendTest: "Send test notification",
            NotificationChannelTestSent: "Test notification sent.",
            NotificationChannelTestFailed: "The test notification could not be sent.",
            NotificationChannelEmails: "Email recipients",
            NotificationChannelEmailsRequired: "Add at least one email recipient.",
            NotificationChannelPhones: "Phone numbers",
            NotificationChannelPhonesRequired: "Add at least one phone number.",
            NotificationChannelChatIds: "Telegram chat IDs",
            NotificationChannelChatIdsRequired: "Add at least one Telegram chat ID.",
            NotificationChannelLanguage: "Language",
            NotificationChannelLanguageHint: "Notifications sent through this channel will use the selected language.",
            NotificationChannelTelegramManagedBot:
                "Telegram delivery uses the bot token configured on the backend. Only recipient chat IDs are managed here.",
            NotificationChannelWebhookUrl: "Webhook URL",
            NotificationChannelWebhookRequired: "Webhook URL is required.",
            NotificationChannelListHint: "Use commas or new lines to enter multiple values.",
            NotificationChannelSecretStored: "A secret is already stored. Leave blank to keep it unchanged.",
            NotificationChannelWebPushHelp:
                "Create the web push channel here. Project users enroll their own browsers from the customer-facing app flow.",
            NotificationChannelType: {
                email: "Email",
                sms: "SMS",
                telegram: "Telegram",
                slack: "Slack",
                teams: "Teams",
                web_push: "Web Push",
            },
            Archive: "Archive",
            Unarchive: "Unarchive",
            ShowArchived: "Show Archived",
        },
    },
};
